// extracted by mini-css-extract-plugin
module.exports = {"subsidiary":"Subsidiary_subsidiary__28Mdu","subsidiaryLogos":"Subsidiary_subsidiaryLogos__BoM5b"};